export interface DynamicConfig {
  appFrontendUrl: string;
  platformFrontendUrl: string;
  docUrl: string;
  zdfsUrl: string;
  polygonUrl: string;
  videosUrl: string;
  subgraphUrl:string
  protocolDefaultUrl: string,
  cordaFrontendUrl: string,
  cordaEnterpriseFrontendtUrl: string,
  fabricFrontendUrl: string,
  environment: string,
  zvaultUrl: string,
  zvaultBackendUrl: string,
  InAppNotificationUrl: string,
  zdexerPortalUrl:string,
  subgraphEndpoint: string,
  itemCode: {
    [key: string]: string
  },
  multi_tenant_domains: {
    zeeve: {
      domain: string,
      images: {
        header_logo: string,
        network_list_logo: string,
        favicon: string
      },
      sharedApi: boolean,
      single_protocol: boolean,
      single_protocol_url: string,
      endpoints: {
        baseUrl: string,
        authUrl: string,
        protocolDefaultUrl: string,
        alertsBackendUrl: string,
      },
      redirections: {
        planCalculator: string,
        allPlan: string,
        docs: string,
      },
      contacts: {
        email: string,
        helpdeskURL: string
      }
    },
    helious: {
      domain: string,
      images: {
        header_logo: string,
        network_list_logo: string,
        favicon: string
      },
      sharedApi: boolean,
      single_protocol: boolean,
      single_protocol_url: string,
      endpoints: {
        baseUrl: string,
        authUrl: string,
        protocolDefaultUrl: string,
      },
      redirections: {
        planCalculator: string,
        allPlan: string,
        docs: string,
      },
      contacts: {
        email: string,
        helpdeskURL: string,
      }
    }
  },
  module: {
    sidebar: string,
  }
  isOrganizationEnabled: boolean
}

//   export const defaultConfig: DynamicConfig = {
//     apiUrl: "http://localhost:8080/zeve.io",
//     authUrl :"auth url",
//     frontenUrl:"frontend url"
//   };

class GlobalConfig {
  config: DynamicConfig | null = null;
}

export const globalConfig = new GlobalConfig();

export const globalConfigUrl = 'config.json';